module.exports = __webpack_public_path__ + "01f43047/img/placeholder.888fcd0b.svg";